import { createAppFromCommonTemplate, lazyImport } from '@helpers'

const { BottegasPage } = lazyImport(
  () => import('@components/Bottegas/BottegasPage'),
  'BottegasPage',
)

const allBottegasEl = document.getElementById('all-bottegas')

export const renderBottegasApp = () => {
  createAppFromCommonTemplate(allBottegasEl, <BottegasPage />)
}
